import React, {useEffect, useState} from "react";
import './boards.scss';
import CourseHeader from "../../../shared/components/AppHeader";
import CourseCards from "../../../shared/components/CourseComponents/CourseCards";
import BoardForm from "../../../shared/components/CourseComponents/BoardForm";
import BoardService from "../../../services/CourseServices/BoardService/board.service";
import PaginationComponent from "../../../shared/components/PaginationComponent";
import EmptyState from "../../../shared/components/EmptyState";

const Board = () => {
    useEffect(()=>{
        fetchBoards(1)
    },[])

    const fetchBoards = (pageNumber:number,searchString?:string) => {
        let queryParams = `?page=${pageNumber}&search=${searchString || ''}`

        BoardService.getBoardsList(queryParams,
            (boards:any,pageMeta:any)=>{
                setCourses([...boards])
                setPaginationMeta(pageMeta)
            },
            ()=>{},
            ()=>{},
        )
    }

    const [courses,setCourses] = useState<any>([]);
    const [paginationMeta,setPaginationMeta] = useState<any>();
    const [currentPageNumber,setCurrentPageNumber] = useState<number>(1);
    const [formVisible,setFormVisible] = useState<boolean>(false);

    const handleSearch = (value:string) => {
        fetchBoards(currentPageNumber,value)
    }

    const handlePageChange = (page:number) => {
        fetchBoards(page);
        setCurrentPageNumber(page);
    }

    return (
        <div className='page-view'>
            <BoardForm title='Create New Board'
                       visible={formVisible}
                       setVisible={setFormVisible}
                       refreshList={fetchBoards}
                       currentPageNumber={currentPageNumber}
            />
            <CourseHeader headerText='Boards'
                          handleSearch={handleSearch}
                          handleHeaderAction={()=>{setFormVisible(true)}}
                          buttonText='Board'
            />
            {courses?.length !== 0 ?
                <>
                    <CourseCards courses={courses}
                                 refreshList={fetchBoards}
                                 currentPageNumber={currentPageNumber}
                    />
                    <PaginationComponent handlePageChange={handlePageChange}
                                         paginationMeta={paginationMeta}
                    />
                </>
                :
                <EmptyState text={'No boards found.'}/>
            }
        </div>
    )
}

export default Board;
